export default __webpack_public_path__ + "static/media/013_photo.c77e4b37.jpg";